
export const root = {
    transitionDuration: '{transition.duration}'
};

export const preview = {
    width: '1.75rem',
    height: '1.75rem',
    borderRadius: '{form.field.border.radius}',
    focusRing: {
        width: '{form.field.focus.ring.width}',
        style: '{form.field.focus.ring.style}',
        color: '{form.field.focus.ring.color}',
        offset: '{form.field.focus.ring.offset}',
        shadow: '{form.field.focus.ring.shadow}'
    }
};

export const panel = {
    shadow: '{overlay.popover.shadow}',
    borderRadius: '{overlay.popover.borderRadius}'
};

export const colorScheme = {
    light: {
        panel: {
            background: '{surface.800}',
            borderColor: '{surface.900}'
        },
        handle: {
            color: '{surface.0}'
        }
    },
    dark: {
        panel: {
            background: '{surface.900}',
            borderColor: '{surface.700}'
        },
        handle: {
            color: '{surface.0}'
        }
    }
};

export default {
    root,
    preview,
    panel,
    colorScheme
};
